"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _TextArea = _interopRequireDefault(require("antd/es/input/TextArea"));

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _tsXlsxExport = require("ts-xlsx-export");

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _api = _interopRequireDefault(require("../../../redux/api"));

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {
  query: '',
  data: undefined,
  previewLength: 10,
  waiting: false,
  error: ''
};

class AdHocQueryLandingPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.getData = async () => {
      const {
        query,
        waiting
      } = this.state;

      if (waiting) {
        return;
      }

      this.setState({
        waiting: true,
        data: undefined,
        error: ''
      });
      let response;

      try {
        response = await (0, _api.default)({
          timeout: -1,
          method: 'post',
          url: '/a/adHocQuery/',
          data: {
            query
          }
        });
        this.setState({
          data: response.data,
          waiting: false
        });
      } catch (err) {
        console.log(JSON.stringify(err));
        this.setState({
          waiting: false,
          error: `${err.message}\n${err.stack}`
        });
      }
    };

    this.enterHandler = async evt => {
      if (evt.code === 'Enter' && evt.ctrlKey) {
        this.getData();
      }
    };
  }

  render() {
    const {
      hasDataAnalystRole
    } = this.props;
    const {
      data,
      previewLength,
      query,
      waiting,
      error
    } = this.state;
    const columns = [];
    const headers = [];

    if (!hasDataAnalystRole) {
      return /*#__PURE__*/_react.default.createElement("div", null, "You do not have the proper role to see this page!");
    }

    if (data) {
      if (data.rows.length) {
        _lodash._.keys(data.rows[0]).forEach(key => {
          headers.push({
            label: key,
            key
          });
          columns.push({
            title: key,
            dataIndex: key
          });
        });
      }
    }

    function exportXSLX() {
      (0, _tsXlsxExport.tsXLXS)().exportAsExcelFile(data.rows).saveAsExcelFile('newFile');
    }

    const fivePxMargin = {
      marginTop: '5px'
    };
    return /*#__PURE__*/_react.default.createElement("div", null, "Enter your query below and hit enter", /*#__PURE__*/_react.default.createElement(_TextArea.default, {
      style: {
        marginTop: '10px',
        marginBottom: '10px'
      },
      rows: 4,
      value: query,
      onPressEnter: this.enterHandler,
      onChange: e => {
        this.setState({
          query: e.target.value
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: waiting,
      onClick: this.getData
    }, "Run Query"), ' ', /*#__PURE__*/_react.default.createElement("span", null, "Press Ctrl-ENTER to run query"), waiting && /*#__PURE__*/_react.default.createElement("div", {
      style: fivePxMargin
    }, /*#__PURE__*/_react.default.createElement(_spin.default, {
      size: "large",
      style: {
        marginLeft: '10px'
      }
    })), error && error.match(/Request failed with status code 408/) ? /*#__PURE__*/_react.default.createElement("div", {
      style: fivePxMargin
    }, /*#__PURE__*/_react.default.createElement("p", null, "This query timed out. Please rewrite it")) : /*#__PURE__*/_react.default.createElement("div", {
      style: fivePxMargin
    }, /*#__PURE__*/_react.default.createElement("pre", null, error)), (data === null || data === void 0 ? void 0 : data.rows) && _lodash._.isArray(data.rows) ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: exportXSLX
    }, "Export XSLX"), /*#__PURE__*/_react.default.createElement("br", null), ' ', /*#__PURE__*/_react.default.createElement("br", null), "Here is a preview of", ' ', /*#__PURE__*/_react.default.createElement(_input.default, {
      style: {
        width: '75px'
      },
      value: previewLength,
      onChange: e => {
        this.setState({
          previewLength: e.target.value
        });
      }
    }), ' ', "rows", /*#__PURE__*/_react.default.createElement("br", null), ' ', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: columns,
      dataSource: _lodash._.slice(data.rows, 0, previewLength),
      pagination: false
    })) : null);
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  user: selectors.getUser,
  hasDataAnalystRole: selectors.hasDataAnalystRole
});

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(AdHocQueryLandingPage);

exports.default = _default;